// extracted by mini-css-extract-plugin
export var emailBlockLink = "_nz-0";